import Module from '../utils/Module';
import ResizeManager from '../utils/ResizeManager';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class AccordionModule extends Module {
  constructor (options) {
    super(options)

    this.onClickOpener = this.onClickOpener.bind(this);
    this.collapseAccordions = this.collapseAccordions.bind(this);
    this.expandAccordion = this.expandAccordion.bind(this)
    this.onKeyEnterPress = this.onKeyEnterPress.bind(this);

    this.DOMEl = this.options.element;

    this.accordionsParagraphs = document.querySelectorAll(".accordion-paragraph h3.title");
    this.btnsOpener = this.DOMEl.querySelectorAll(".accordion-paragraph__opener");

    this.titleContent = this.DOMEl.querySelectorAll(".title-head");
    this.descriptionContent = this.DOMEl.querySelector(".description-head");


    this.timeline = gsap.timeline().pause();

    this.init();

    ResizeManager.bind('accordion-resize', this.onResize.bind(this));
  }

  init () {
    this.collapseAccordions();

    if(window.innerWidth >= 1024)
    {
      this.expandAccordion(this.accordionsParagraphs[0].closest(".accordion-paragraph"));
    }

    this.accordionsParagraphs.forEach( button =>{
      button.addEventListener('click', this.onClickOpener);
      button.addEventListener('keypress', this.onKeyEnterPress);

      const triggerButtonAnimation = ScrollTrigger.create({
        trigger: button.closest(".accordion-paragraph"),
        start: "top center+=100",
        onEnter: ()=>{
          gsap.to(button.closest(".accordion-paragraph"), {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
        },
        onEnterBack: ()=>{
          gsap.to(button.closest(".accordion-paragraph"), {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
        }
      });
    });

    this.titleContent.forEach(title =>{
      ScrollTrigger.create({
        trigger: title,
        start: "top center+=100",
        onEnter: ()=>{
          gsap.to(title, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
        },
        onEnterBack: ()=>{
          gsap.to(title, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
        }
      });
    });
    if(this.descriptionContent) this.timeline.to(this.descriptionContent, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');

    const triggerModuleAnimation = ScrollTrigger.create({
      trigger: this.DOMEl,
      start: "top center+=100",

      onEnter: ()=>{
        this.timeline.play();
      },
      onEnterBack: ()=>{
        this.timeline.play();
      }
    });
  }

  onKeyEnterPress(e) {
    if (e.keyCode === 13) {
      const parentContainer = e.target.closest(".accordion-paragraph");
      if (!parentContainer.classList.contains("accordion-paragraph--expanded")) {
        this.trackClick(parentContainer);
      }
      this.collapseAccordions();
      this.expandAccordion(parentContainer);
    }
  }

  onClickOpener(e) {
    const parentContainer = e.target.closest(".accordion-paragraph");
    if (!parentContainer.classList.contains("accordion-paragraph--expanded")) {
      this.trackClick(parentContainer);
    }
    this.collapseAccordions();
    this.expandAccordion(parentContainer);
  }

  expandAccordion(accordion) {
    accordion.classList.add("accordion-paragraph--expanded");
    let expandedHeight = accordion.querySelector(".accordion-paragraph__wrapper").getBoundingClientRect().height;
    accordion.style.maxHeight = `${expandedHeight}px`;
  }

  collapseAccordions() {
    this.accordionsParagraphs.forEach( accordionTitle =>{
      var accordion = accordionTitle.closest(".accordion-paragraph");
      let titleHeight = accordion.querySelector(".title").getBoundingClientRect().height;
      accordion.style.maxHeight = `${titleHeight}px`;
      accordion.classList.remove("accordion-paragraph--expanded");
    });
  }

  onResize() {
    this.accordionsParagraphs.forEach( accordionTitle =>{
      var accordion = accordionTitle.closest(".accordion-paragraph");
      if(accordion.classList.contains("accordion-paragraph--expanded")) {
        const expandedHeight = accordion.querySelector(".accordion-paragraph__wrapper").getBoundingClientRect().height;
        accordion.style.maxHeight = `${expandedHeight}px`;
      }else{
        const titleHeight = accordion.querySelector(".title").getBoundingClientRect().height;
        accordion.style.maxHeight = `${titleHeight}px`;
      }
    });
  }

  trackClick(accordion) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "accordeon interaction",
        "action": accordion.querySelector(".title").textContent,
        "label": window.location.href
      }
    });
  }
}
